import { Status } from './enums/status.enum';

export function isArchivedUser(status: string | null) {
  return (+status! as Status) === Status.Archived;
}
